// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__MzOqM","error__icon":"style_error__icon__2KAtO","error__text":"style_error__text__3Hu2U","error__url":"style_error__url__21tco"};